<template>
  <div>
    <cover :topImg="topImg"/>
    <div class="aboutUs ptb60 bgF0F5FF">
      <div class="type-center">
        <div class="publicTitle">
          <div class="">公司简介</div>
          <div class="publicTitle-text">Company Profile</div>
          <div class="publicTitle-line"/>
        </div>
        <div class="flex f17 cl46494D mt30">
          <div>
            <div class="mt30 f36 font-bold cl111">
              {{ $i18n.locale == 'zh' ? configs.au_cn.zhVal : configs.au_cn.enVal }}
            </div>
            <div class="bg053EB2 mt25" style="width: 51px;height: 5px"/>
            <div class="mt60 f24 font-bold cl111">
              {{ $i18n.locale == 'zh' ? configs.au_estab.zhVal : configs.au_estab.enVal }}
            </div>
            <div class="mt10 line-clamp7">
              {{ $i18n.locale == 'zh' ? configs.au_descr.zhVal : configs.au_descr.enVal }}
            </div>
            <div class="flex al-cn ju-sp mt30">
              <div>
                <div><span class="f36 font-bold cl415AEA mr5">200</span> {{ $t('home.人') }}</div>
                <div>{{ $t('home.在职员工') }}</div>
              </div>
              <div style="height: 47.5px;width: 2px;background: #C5C5C5"/>
              <div>
                <div><span class="f36 font-bold cl415AEA mr5">1.4</span> {{ $t('home.千m²') }}</div>
                <div>{{ $t('home.厂区占地面积') }}</div>
              </div>
            </div>
          </div>
          <img class="aboutUs-img ml60" src="@/assets/image/aboutUs.png"/>
        </div>
      </div>
    </div>
    <div class="mb50 productService">
      <div class="type-center">
        <div class="publicTitle">
          <div class="">产品服务</div>
          <div class="publicTitle-text">Product Service</div>
          <div class="publicTitle-line"/>
        </div>
        <div class="flex mt30" v-if="productServices.length">
          <div class="productService-div">
            <img class="mr15 productService-left"
                 :src="$i18n.locale == 'zh' ? productServices[0].img : productServices[0].imgEn">
            <div class="productService-content">
              <div class="productService-content-title">
                {{ $i18n.locale == 'zh' ? productServices[0].title : productServices[0].titleEn }}
              </div>
              <div class="productService-content-text">
                {{ $i18n.locale == 'zh' ? productServices[0].descr : productServices[0].descrEn }}
              </div>
            </div>
          </div>
          <div>
            <div class="productService-div mb15" v-if="productServices[1]">
              <img class="productService-right"
                   :src="$i18n.locale == 'zh' ? productServices[1].img : productServices[0].imgEn">
              <div class="productService-content">
                <div class="productService-content-title">
                  {{ $i18n.locale == 'zh' ? productServices[1].title : productServices[0].titleEn }}
                </div>
                <div class="productService-content-text">
                  {{ $i18n.locale == 'zh' ? productServices[1].descr : productServices[1].descrEn }}
                </div>
              </div>
            </div>
            <div class="productService-div" v-if="productServices[2]">
              <img class="productService-right"
                   :src="$i18n.locale == 'zh' ? productServices[2].img : productServices[0].imgEn">
              <div class="productService-content">
                <div class="productService-content-title">
                  {{ $i18n.locale == 'zh' ? productServices[2].title : productServices[2].titleEn }}
                </div>
                <div class="productService-content-text">
                  {{ $i18n.locale == 'zh' ? productServices[2].descr : productServices[2].descrEn }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="corporatePhilosophy">
      <div class="corporatePhilosophy-content">
        <div class="type-center pt60">
          <div class="publicTitle">
            <div class="">企业理念</div>
            <div class="publicTitle-text">Corporate Philosophy</div>
            <div class="publicTitle-line"/>
          </div>
          <div class="mt30 cl46494D fB400">
            <div class="f24 mb15">{{ $i18n.locale == 'zh' ? configs.cp_title1.zhVal : configs.cp_title1.enVal }}</div>
            <div class="f18 mb45 text-indent2">
              {{ $i18n.locale == 'zh' ? configs.cp_content1.zhVal : configs.cp_content1.enVal }}
            </div>
            <div class="f24 mb15">{{ $i18n.locale == 'zh' ? configs.cp_title2.zhVal : configs.cp_title2.enVal }}</div>
            <div class="f18 text-indent2">
              {{ $i18n.locale == 'zh' ? configs.cp_content2.zhVal : configs.cp_content2.enVal }}
            </div>
          </div>
        </div>
      </div>
      <div class="corporatePhilosophy-img"></div>
      <div class="white-color bg2661D8 ptb20">
        <div class="type-center">
          <div class="f28">{{ $i18n.locale == 'zh' ? configs.ci_cu_title.zhVal : configs.ci_cu_title.enVal }}</div>
          <div class="f18 mt10 text-indent2">
            {{ $i18n.locale == 'zh' ? configs.cl_cu_content.zhVal : configs.cl_cu_content.enVal }}
          </div>
        </div>
      </div>
    </div>
    <div class="type-center mt40">
      <div class="publicTitle">
        <div class="">联系我们</div>
        <div class="publicTitle-text">Contact Us</div>
        <div class="publicTitle-line"/>
      </div>
      <div class="flex ju-cn mt30">
        <img src="@/assets/image/aboutUs/contactUs.png"/>
      </div>
    </div>
  </div>
</template>
<script>
import {getConfigs, getProductServices} from "@/api/api";

export default {
  name: "",
  data() {
    return {
      topImg: require('@/assets/image/aboutUs/topImg.png'),
      configs: {},
      productServices: [],
    };
  },

  created() {
    this.getConfigs();
    this.getProductServices();
  },
  methods: {
    //配置信息
    getConfigs() {
      getConfigs().then(res => {
        if (res.code == 1) {
          this.configs = res.data;
          this.$store.commit('setConfigs', res.data)
        }
      }).catch(err => {
      });
    },
    // 获取产品展示
    getProductServices() {
      getProductServices().then(res => {
        if (res.code == 1) {
          if (res.data && res.data.length > 3) {
            this.productServices = res.data.slice(0, 3);
          } else {
            this.productServices = res.data || [];
          }
        }
      }).catch(err => {
      });
    }
  },
}
</script>
<style scoped lang="scss">
.productService {
  &-left {
    width: 596px;
    height: 612px;
  }

  &-right {
    width: 596px;
    height: 296px;
  }

  &-div {
    position: relative;
  }

  &-content {
    position: absolute;
    left: 20px;
    bottom: 20px;
    font-weight: 400;
    font-size: 16px;
    color: #FFFFFF;

    &-title {
      font-size: 20px;
    }
  }
}

.corporatePhilosophy {
  &-content {
    background: url('../../assets/image/aboutUs/corporatePhilosophyBG.png') no-repeat;
    background-size: 100% 100%;
    height: 577px;

  }

  &-img {
    background: url('../../assets/image/aboutUs/corporatePhilosophy.png') no-repeat;
    background-size: 100% 100%;
    height: 966px;
  }
}
</style>
